import api from "./api";

export const getAll = async (params) => {
    const { data } = await api.get("/campaign-landing-pages", { params });
    return data.landingPages || data || [];
};

export const get = async (id) => {
    const { data } = await api.get(`/campaign-landing-pages/${id}`);
    return data;
};

export const create = async (landingPageData) => {
    const { data } = await api.post("/campaign-landing-pages", landingPageData);
    return data;
};

export const update = async (id, landingPageData) => {
    const { data } = await api.put(`/campaign-landing-pages/${id}`, landingPageData);
    return data;
};

export const remove = async (id) => {
    const { data } = await api.delete(`/campaign-landing-pages/${id}`);
    return data;
};
